import { useColumnsAgendamientos } from "@/erp/operaciones/agendamiento/shared/hooks";
import {
  cellLineaRazonSocial,
  EstadosAgendamientoEnumChoice,
  EstadosContratoChoiceEnum,
  ModulosEnumChoice,
  ROUTER_PATHS,
  TABLE_CONSTANTS_COLUMS,
} from "@/shared";
import { useFetchAgendamientos } from "@/shared/actions/erp";
import { GeneralTable } from "@/shared/components/ui";
import ModalMotivoRechazo from "@/shared/components/ui/ModalMotivoRechazo/ModalMotivoRechazo";
import { useModalMotivoRechazo } from "@/shared/components/ui/ModalMotivoRechazo/useModalMotivoRechazo";
import {
  useLoaders,
  useTableFilter,
  useTableServerSideFiltering,
} from "@/shared/hooks";
import {
  Agendamiento,
  IDataBitacoraRespById,
  IDataPreventa,
} from "@/shared/interfaces";
import { useDiccionarioMotivo } from "@/store/erp/diccionario_motivo/diccionario_motivo.store";
import { useUiStore } from "@/store/ui";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ForumRoundedIcon from '@mui/icons-material/ForumRounded';
import { Grid, IconButton, Tooltip } from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { RiImageEditFill } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import EditAgendamientoImagen from "../edit_agendamiento_imagen/EditAgendamientoImage";
import useEstadoInstalacionSofnet from "@/shared/hooks/useEstadoInstalacionSofnet";

const clientesFibraOReturnUrl = ROUTER_PATHS.clientes.clienteContratoNav;

interface AgendamientoAgendadoPageProps {
  estado_agendamiento: EstadosAgendamientoEnumChoice;
  estado_contrato_exclude?: EstadosContratoChoiceEnum;
}
export default function AgendamientoAgendadoTable({
  estado_agendamiento,
  estado_contrato_exclude,
}: AgendamientoAgendadoPageProps) {
  const navigate = useNavigate();

  ///* State
  const [modalEditImagen, setModalEditImagen] = useState(false);

  // PERF: useForm<IDataPreventa (139 props) & {…}> hacía explotar Path<T> en el tsc. Tipo plano; runtime igual.
  const formEditImagen = useForm<Record<string, any> & { id_agendamiento: string }>();

  ///* Hook

  const useHookModalMotivoRechazo = useModalMotivoRechazo({
    modulo: ModulosEnumChoice.AGENDAMIENTO,
  });

  const {
    handleValidacion
  } = useEstadoInstalacionSofnet()

  const setConfirmDialog = useUiStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiStore((s) => s.setConfirmDialogIsOpen);

  const {
    emitGetVentaById,
    //openCreaBitacora,
    setOpenCreaBitacora,
    setDetalle,
    //detalle,
    setFaseVenta,
    setOpen,
    socket,
  } = useDiccionarioMotivo();

  const { agendamientoColumnaVentas } = useColumnsAgendamientos();
  const { pagination, dateBefore, dateAfter, setPagination } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;

  ///* React Query

  const {
    isLoading,
    data: agendaRes,
    isRefetching,
  } = useFetchAgendamientos({
    enabled: true,
    params: {
      estado_agendamiento: estado_agendamiento,
      page: pageIndex + 1,
      page_size: pageSize,
      fecha_creacion_after: dateAfter,
      fecha_creacion_before: dateBefore,
      ...filterObject,
      filterByState: false,
      contrato_estado_contrato_exclude: estado_contrato_exclude || undefined,
    },
  });

  useLoaders(isLoading || isRefetching);

  //if (isLoading || isRefetching) return <LoaderComponent />

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {/* <CustomSearch
            onChange={onChangeFilter}
            value={globalFilter}
            text="por Identificación"
            onChangeRangeDate={onChangeRangeDate}
            cleanFilter={cleanFilter}
          /> */}
        </Grid>
        <Grid item xs={12}>
          <GeneralTable<Agendamiento>
            columns={agendamientoColumnaVentas}
            data={agendaRes?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={agendaRes?.data?.count}
            // // actions
            actionsColumnSize={TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM}
            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}
            // crud
            positionActionsColumn="first"
            enableColumnActions={true}
            canEdit={false}
            showCustomActionBtnSpace={true}
            customActionBtnSpace={(row) => {
              return (
                <Grid container spacing={0}>
                  <Grid item>
                    <Tooltip title={"Crear Bitácora"} placement="top">
                      <IconButton
                        ///onClick={() => handleOpenChat(row)}
                        onClick={() => {

                          
                          if (!socket) return;
                          

                          socket.emit(
                            "getVentaById",
                            {
                              numero_referencia_venta:
                                row.preagendamiento_data?.id_preagendamiento,
                            },
                            (data: IDataBitacoraRespById) => {

                              console.log('getVentaById',data);
                              
                              if (data.code == 200) {
                                emitGetVentaById(
                                  row.preagendamiento_data?.id_preagendamiento!
                                );
                                setOpen(true);
                                return;
                              }

                              const details = {
                                numero_referencia_venta:
                                  row.preagendamiento_data?.id_preagendamiento,
                                identificacion_cliente:
                                  row.prospecto_data?.identificacion,
                                nombre_cliente: cellLineaRazonSocial(
                                  row.contrato_data,
                                  row.prospecto_data?.razon_social!
                                ),
                                canal_venta:
                                  row.prospecto_data?.canal_venta_create,
                                vendedor: row.prospecto_data?.user_create,
                                fecha_aceptacion:
                                  row.preventa_data?.fecha_aceptacion,
                              };
                              setDetalle(details);
                              setFaseVenta(ModulosEnumChoice.AGENDAMIENTO);
                              setOpenCreaBitacora(true);
                              return;
                            }
                          );
                        }}
                      >
                        <ForumRoundedIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>

                  <Grid item>
                    <Tooltip
                      title={"Editar imagen"}
                      placement="top">
                      <IconButton
                        color="info"
                        onClick={() => {
                          if (
                            row.contrato_data != null &&
                            row.contrato_data.estado_actualizacion ===
                            EstadosContratoChoiceEnum.SOLICITUD_CORRECCION
                          ) {
                            setConfirmDialogIsOpen(true);
                            setConfirmDialog({
                              cancelTextBtn: "Salir",
                              isOpen: true,
                              title: "¡Solicitud de correción!",
                              subtitle:
                                "No puedes realizar actualizaciones mientras tengas una solicitud de corrección emitida por el área de contratos. ¿Cambiar a pendiente de actualizar?",
                              onClose() {
                                setConfirmDialogIsOpen(false);
                              },
                              async onConfirm() {
                                navigate(
                                  `${clientesFibraOReturnUrl}/actualizar/${row.contrato_data.id_contrato}`
                                );
                                setConfirmDialogIsOpen(false);
                              },
                            });
                            return;
                          }

                          setModalEditImagen(true);
                          const {
                            preventa_data,
                            forma_pago_data,
                            id_agendamiento,
                          } = row;

                          formEditImagen.reset({
                            ...preventa_data,
                            id_agendamiento: id_agendamiento,
                            codigo_forma_pago: forma_pago_data.forma_pago,
                          });
                        }}
                      >
                        <RiImageEditFill />
                      </IconButton>
                    </Tooltip>
                  </Grid>

                  <Grid item>
                    <Tooltip title={"Cancelar"} placement="top">
                      <IconButton
                        onClick={async () => {

                          const aux = await handleValidacion(row?.preagendamiento_data?.id_instalacion_externa);

                          if(aux) return;

                          useHookModalMotivoRechazo.setDialogContentText(
                            `Estás a punto de cancelar un Agendamiento del cliente ${row.prospecto_data?.razon_social} con identificación ${row.prospecto_data?.identificacion}. ¿Estás seguro? Este cambio es irreversible.`
                          );
                          useHookModalMotivoRechazo.setModalCancelar(true);
                          useHookModalMotivoRechazo.reset({
                            id: row.id_agendamiento,
                            identificacion: row.prospecto_data?.identificacion,
                            razon_social: row.prospecto_data?.razon_social,
                            observaciones: row.observaciones,
                            id_preagendamiento:
                              row.preagendamiento_data?.id_preagendamiento,
                          });
                        }}
                      >
                        <HighlightOffIcon color="error" />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              );
            }}
          />
        </Grid>
      </Grid>

      {modalEditImagen && (
        <EditAgendamientoImagen
          open={modalEditImagen}
          setOpen={setModalEditImagen}
          form={formEditImagen as any}
        />
      )}

      {/*Modal para cancelar*/}
      <ModalMotivoRechazo {...useHookModalMotivoRechazo} />
    </>
  );
}
